/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowUpRightOut16: {
  name: 'arrow-up-right-out-16';
  data: string;
} = {
  name: 'arrow-up-right-out-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.384 4.101 7.12 10.364A1 1 0 1 1 5.707 8.95l6.261-6.261-1.814-1.81a.5.5 0 0 1 .351-.855L15.498 0A.5.5 0 0 1 16 .498v5.009a.5.5 0 0 1-.853.354L13.384 4.1zM6 1v2H2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10h2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4z"/></svg>`
};
